import React from 'react';
import {
  Box,
} from '@mui/material';
import { GroundTruthMultiChoice, QuestionMultiChoice } from '../../redux/types';

type Props = {
  payload: GroundTruthMultiChoice['payload'];
  question: QuestionMultiChoice;
};

const GTMultiChoiceScore: React.FC<Props> = ({
  question,
  payload,
}: Props) => {
  const getStrictScoreList = (
    q: QuestionMultiChoice,
    p: GroundTruthMultiChoice['payload'],
  ) => {
    const list = q.payload?.filter((op) => {
      const score = p.truths[op.id];
      return !!score;
    }).map((op) => op.text);
    return list;
  };

  const getScoreList = (
    q: QuestionMultiChoice,
    p: GroundTruthMultiChoice['payload'],
  ) => {
    const list = q.payload?.filter((op) => {
      const score = p.truths[op.id];
      return !!score;
    }).map((op) => `${op.text} (${p.truths[op.id]})`);
    return list;
  };

  return (
    <Box>
      {
        payload.strict && (
          <Box>
            {
              getStrictScoreList(question, payload)?.map((i) => (
                <Box key={i}>
                  {i}
                </Box>
              ))
            }
            (
              {payload.score}
            )
          </Box>
        )
      }
      {
        !payload.strict && (
          <Box>
            {
              getScoreList(question, payload)?.map((i) => (
                <Box key={i}>
                  {i}
                </Box>
              ))
            }
          </Box>
        )
      }
    </Box>
  );
};

export default GTMultiChoiceScore;
